import fetch from './fetch';
import { OfferApi } from './offer.types';

export const getOffers = (): OfferApi => {
  return fetch('GET', '/offers');
};
